import { pdfjs } from 'react-pdf';

/**
 * Worker legacy de pdfjs-dist 3.11.174, empaquetado con react-pdf 7.7.3.
 * Si se actualiza react-pdf o pdfjs-dist, hay que volver a copiar
 * node_modules/pdfjs-dist/legacy/build/pdf.worker.min.js
 * a public/pdfjs/pdf.worker.min.js sin modificar el binario.
 * No cambia el worker de EmbedPdf: solo se asigna al abrir este visor.
 */
const configurePdfWorker = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  pdfjs.GlobalWorkerOptions.workerSrc = `${publicUrl}/pdfjs/pdf.worker.min.js`;
};

export default configurePdfWorker;
